/**
 * "How to Use Recovery Trauma™" — the friendly guide shown when someone picks
 * the "Using the Platform" topic in support. Kept in one place so the support
 * chat card and the assistant's approved knowledge always say the same thing.
 */

export type HowToUseSection = { icon: string; title: string; body: string };

export const HOW_TO_USE_TITLE = "How to Use Recovery Trauma™";

export const HOW_TO_USE_SECTIONS: HowToUseSection[] = [
  {
    icon: "🌱",
    title: "Getting started",
    body: "Create a free account from the Sign Up page, then sign in with your email (or Google, if you used that). Once you're signed in, your Dashboard is your home base — it shows your journals, exercises, events and saved content.",
  },
  {
    icon: "🧭",
    title: "Finding content",
    body: "Use the menu to explore Learn / Understand for gentle education about trauma, and Explore for recovery tools, exercises and resources. On mobile, everything is in the menu at the bottom of the screen.",
  },
  {
    icon: "🎡",
    title: "Emotion & Trauma Response Wheels",
    body: "Tap any emotion or response on the wheels to learn a little about it and find support that fits. Visitors can explore the basics; the full breakdowns and personalised suggestions are part of membership.",
  },
  {
    icon: "🧘",
    title: "Exercises & practices",
    body: "Open any grounding, breathing, meditation or journaling tool and follow the steps at your own pace. You can stop or leave any exercise at any time — there's no pressure to finish.",
  },
  {
    icon: "🔒",
    title: "Membership content",
    body: "Some resources are free for everyone. Full exercises, tools, journals and premium content need an active membership — you'll see a friendly lock and an option to join whenever something is members-only.",
  },
  {
    icon: "👤",
    title: "Profile & membership",
    body: "Go to Profile to see your account details, and Profile → My Membership to view your plan, billing provider and renewal date.",
  },
  {
    icon: "📅",
    title: "Live sessions & events",
    body: "Members can find upcoming live sessions on the Events page and on the Dashboard. Tap an event to see the details and save your spot; joining information appears there before the session starts.",
  },
  {
    icon: "💬",
    title: "Getting help",
    body: "If something isn't working or you can't find what you need, you're in the right place — ask here in Support, or use the Contact Support form and the team will reply by email.",
  },
];

/** Plain-text version for the support assistant's approved knowledge. */
export const HOW_TO_USE_KNOWLEDGE = HOW_TO_USE_SECTIONS.map(
  (s) => `${s.title}: ${s.body}`,
).join("\n");
